import React from "react";
import Sidebar from "../components/SidebarManager.js";
// import { SidebarManager } from "../components/SidebarManager.js";

const AdminLayout = ({ children }) => (
  <div className="App flex flex-row">
    <Sidebar />
    {children}
  </div>
);

export default AdminLayout;
